<template lang="pug">
.table-responsive
  table.table.table-sm.table-bordered.table-striped.table-hover.tb-authority
    thead
      tr.thead-dark
        th.text-center.col-checkbox(style="width: 5%;")
          .custom-checkbox.custom-control
            input.custom-control-input(
              :id="category + '-all'",
              type="checkbox",
              :data-checkbox-role="'dad'",
              v-model="allSelected",
              @change="rowSelectAll"
            )
            label.custom-control-label(:for="category + '-all'") &nbsp;
        th.align-middle(colspan=2)
          span(:title="$t('ui.' + category)") {{ $t('ui.' + category) }}
          i.toggle-btn.fas(:class="iconClass", @click="toggleCollapse")
    tbody.clusterize-content(:class="{ collapsed: isCollapsed }")
      //- tr(v-for="(item, index) in dataList" :key="index" :class="{ 'selectedRow': selectedRow(item) }" v-if="isOperatorOnlyPage(item.value)")
      tr(v-for="(item, index) in dataList" :key="index" :class="{ 'selectedRow': selectedRow(item) }")
        td.text-center.col-checkbox
          .custom-checkbox.custom-control
            input.custom-control-input(
              :id="category + '-' + index",
              type="checkbox",
              v-model="item.checked"
              :disabled="checkDisabled(item.value)"
            )
            label.custom-control-label(:for="category + '-' + index") &nbsp;
        td.align-middle
          span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
        td.text-center.col-checkbox
          .custom-checkbox.custom-control(v-if="!isViewOnlyPage(item.value,item.category) && !isView")
            input.custom-control-input(
              :id="'e_' + category + '-' + index",
              type="checkbox",
              v-model="item.edit"
              :disabled="!item.checked"
              :key="updateKey"
            )
            label.custom-control-label(:for="'e_' + category + '-' + index") &nbsp;{{ $t('ui.edit') }}

</template>

<script>
import authority from "@/authority";
import authorityOpr from "@/authorityOpr";
import config from "@/config";

export default {
  props: {
    category: {
      type: String,
      default: ""
    },
    isView: {
      type: Boolean,
      default: false
    },
    updateKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    let list = [2].includes(this.$store.getters.accountType) ? authorityOpr.list : authority.list;

    return {
      authority_list: list,
      isCollapsed: true,
      isUat: config.isUat
    }
  },
  computed: {
    iconClass() {
      return this.isCollapsed ? 'fa-plus' : 'fa-minus';
    },
    allSelected: {
      get() {
        if (this.dataList.length === 0) return false;
        return this.dataList.every(item => item.checked);
      },
      set(value) {
        this.dataList.forEach(item => {
          item.checked = value;
        });
        return value;
      }
    },
    dataList() {
      // return this.authority_list.filter(d => { return d.category == this.category && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
      let list = this.authority_list
      if(this.isUat == 'false') {
        if(!['BDT'].includes(this.getCurrencyCode)) {
          list = list.filter(d => { return d.value != 'pendingbetlist9w' })
        } else {
          list = list.filter(d => { return d.value != 'pendingbetlistothers' })
        }
        if(!this.fundTransferEnable) {
          list = list.filter(d => { return d.value != 'ftprovider' })
        }
      }

      if(!this.isAdmin) {
        list = list.filter(d => { return d.value != 'clearoutstandinglog'})
      }

      return list.filter(d => { return d.category == this.category && (d.type == "both" || d.type == (this.isOperator == true ? "opr" : "admin")) });
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    isAdminOperator() {
      return [2,5].includes(this.$store.getters.accountType);
    },
    isAdmin() {
      return [5].includes(this.$store.getters.accountType);
    },
    getAuthOriginalChecked() {
      return this.$store.getters.authOriginalChecked;
    },
    // build a set of all values once (auto-updates when getAuthOriginalChecked changes)
    disabledAuthSet() {
      return new Set(this.getAuthOriginalChecked.map(item => item.value));
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    fundTransferEnable() {
      return config.fundTransferEnable == "1";
    }
    // authority_list() {
    //   return this.isOperator ? authorityOpr.list : authority.list;
    // }
  },
  watch: {
    // Watch for changes in each item's `checked` property
    authority_list: {
      handler(newList) {
        newList.forEach(item => {
          if (!item.checked) {
            // If checked is false, disable edit and set it to false
            item.edit = false;
          }
        });
      },
      deep: true  // Ensures the watcher is triggered on nested changes in the object
    }
  },
  methods: {
    checkDisabled(value) {
      return this.disabledAuthSet.has(value);
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    rowSelectAll() {
      this.$nextTick(() => {
        this.$emit('select-all', this.allSelected, this.dataList); // Emit the updated value
      });
    },
    selectedRow(item) {
      return item.checked;
    },
    isViewOnlyPage(pages, cat) {
      var list = ['systembalance', 'settings', 'gameresultslots', 'gameresultlivecasino', 'gameresultsportsbook', 'gameresultcockfight', 'gameresultrescue',
              'sitelist', 'themepurchased','bankstatement', 'bankstatementdaily', 'bankaff', 'dailystatementaff', 'dailydepositaff', 'dailywinloseaff',
              'adjustmentlogaffiliate', 'newwebsite', 'operatorinformation', 'gameresultreward', 'gameresultfreeslots', 'gameresultothers', 'pendingbetlistwbet',
              'pendingbetlist9w', 'pendingbetlistothers', 'operatorsummary', 'dashboardop', 'settlementlogaffiliate', 'adjustfreebalancelog']

      if(this.isOperator) {
        let readonlylist = ['affiliatelist', 'approveaffiliate', 'ticketlistaffiliate', 'pendingticketaffiliate', 'ticketlistautowithdrawal']
        list.push(...readonlylist);
      }

      if(['MYR'].includes(this.getCurrencyCode)) {
        list.push('cpi')
      }

      return list.includes(pages)
    },
    isOperatorOnlyPage(pages) {
      if(!this.isOperator) {
        if(pages == 'domainop') return
      } else {
        if(pages == 'domainlist') return
        if(pages == 'sitelist') return
      }
      return pages;
    }
  }
}
</script>

<style lang="css" scoped="true">
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 8px;
  border: 1px solid #ddd;
}
th {
  position: relative;
  text-align: left;
}
.toggle-btn {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
}
tbody.collapsed {
  display: none;
}
</style>
